<div class="d-flex justify-content-between">
  <div class="form-group">
    <div class="dropdown dropdown-bhp">
      <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
        <input class="dropdown-toggle" [ngModel]="selectedName | translate" type="text" readonly />
        <span class="label-dropdown"></span>
        <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
      </div>
      <ul class="dropdown-menu">
        <li class="dropdown-item" (click)="onSelectChange('processCompliance')" value="processCompliance" [ngClass]="select === 'processCompliance' ? 'active' : ''" >{{ 'DASHBOARD.PROCESS_COMPLIANCE' | translate }}</li>
        <li class="dropdown-item" (click)="onSelectChange('frequencyDistribution')" value="frequencyDistribution" [ngClass]="select === 'frequencyDistribution' ? 'active' : ''" >{{ 'EVALUATION.FREQUENCY_DISTRIBUTION.DISPLAY_TEXT' | translate }}</li>
        <li class="dropdown-item" (click)="onSelectChange('subStepCompliance')" value="subStepCompliance" [ngClass]="select === 'subStepCompliance' ? 'active' : ''" >{{ 'EVALUATION.SUB_STEP_COMPLIANCE' | translate }}</li>
        <li class="dropdown-item" (click)="onSelectChange('individualData')" value="individualData" [ngClass]="select === 'individualData' ? 'active' : ''" >{{ 'EVALUATION.OVERVIEW_INDIVIDUAL_DATA_1' | translate }}</li>
        <li class="dropdown-item" (click)="onSelectChange('comments')" value="comments" [ngClass]="select === 'comments' ? 'active' : ''" >{{ 'SOP_MANAGEMENT.COMMENTS' | translate }}</li>
    </ul>
    </div>
  </div>
</div>

<kendo-excelexport [data]="gridData" filename="ReportMyHygieneSOP.xlsx" #excelexport>
    <kendo-excelexport-column field="{{i.field}}" title="{{i.title | translate}}"
        *ngFor="let i of fields,  let indexx = index;" class="non-action-columns" [width]="i.width">
       <ng-template kendoGridCellTemplate let-dataItem="dataItem" *ngIf="i.ngTemplate">
        {{i.ngTemplate(dataItem)}}
        </ng-template>
    </kendo-excelexport-column>
</kendo-excelexport>

<ng-container *ngFor="let result of results">
  <kendo-excelexport [data]="result.gridData" filename="ReportMyHygieneSOP.xlsx" #multiselectExcelExport>
    <kendo-excelexport-column field="{{i.field}}" title="{{i.title | translate}}"
        *ngFor="let i of result.fields,  let indexx = index;" class="non-action-columns" [width]="i.width">
       <ng-template kendoGridCellTemplate let-dataItem="dataItem" *ngIf="i.ngTemplate">
        {{i.ngTemplate(dataItem)}}
        </ng-template>
    </kendo-excelexport-column>
  </kendo-excelexport>
</ng-container>

<kendo-excelexport *ngIf="secGridData" [data]="secGridData" filename="ReportMyHygieneSOP.xlsx" #secExcelexport>
    <kendo-excelexport-column field="{{i.field}}" title="{{i.title | translate}}"
        *ngFor="let i of secFields,  let indexx = index;" class="non-action-columns" [width]="i.width">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem" *ngIf="i.ngTemplate">
            {{i.ngTemplate(dataItem)}}
        </ng-template>
    </kendo-excelexport-column>
</kendo-excelexport>

